module.exports = __webpack_public_path__ + "img/1446214817.4a687576.jpg";